import { Divider, IconButton } from "@mui/material";
import React, { ReactElement } from "react";

import useProjectScene from "../../hooks/use-project-scene";
import { classNames } from "../../utils/classes";
import Brightness from "../icons/fill/brightness";

type Props = {
  aspectRatio: number | null;
  setAspectRatio(aspectRatio: number | null): void;
};

export default function BackgroundAspectRatioActions(
  props: Props,
): ReactElement {
  const { aspectRatio, setAspectRatio } = props;

  const { selection } = useProjectScene();

  const aspectRatioOptions = [
    { name: "Default", value: null },
    { name: "1:1", value: 1 / 1 },
    { name: "16:9", value: 16 / 9 },
    { name: "9:16", value: 9 / 16 },
    { name: "3:4", value: 3 / 4 },
    { name: "4:3", value: 4 / 3 },
  ];
  const selectedOptionIndex = aspectRatioOptions.findIndex(
    (option) =>
      aspectRatio === option.value ||
      (aspectRatio !== null &&
        option.value !== null &&
        Math.abs(aspectRatio - option.value) < 0.001),
  );

  return (
    <>
      <Divider />
      {aspectRatioOptions.map((option, index) => {
        const selected = index === selectedOptionIndex;
        return (
          <IconButton
            key={option.name}
            className={classNames(
              "!py-[5px]",
              selected ? "!text-[#7a7676]" : "",
            )}
            onClick={() => setAspectRatio(option.value)}
          >
            {option.name}
          </IconButton>
        );
      })}
      <Divider />

      <IconButton>
        <input
          className="absolute cursor-pointer opacity-0"
          type="color"
          onChange={(e) => selection.selectBackgroundColor(e.target.value)}
        />
        <Brightness />
      </IconButton>
    </>
  );
}
